import { Component, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { WsSignInService } from 'src/app/ws/wsSignIn/ws-sign-in.service';
import { lastValueFrom } from 'rxjs';
import { SharedPrefrences } from 'src/app/utils/utils.service';
import { MUpdateUserRequest } from 'src/app/pages/sign-up/sign-up.module';
import { CommonBehaviorChangeService } from 'src/app/utils/common-behaviour-service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login-popup',
  templateUrl: './login-popup.component.html',
  styleUrls: ['./login-popup.component.scss']
})
export class LoginPopupComponent {
  @Input() public type: any;
  @Input() public productType: any;
  signInFormgroup!: FormGroup;
  verifyOtpFormgroup!: FormGroup;
  addUserFormgroup!: FormGroup;
  mUpdateUserRequest: MUpdateUserRequest = new MUpdateUserRequest();
  userId: any
  selectedGender: any;
  resendLoader: boolean = false;
  isLoading: boolean = false;
  get phonef() {
    return this.signInFormgroup.controls;
  }

  get otpf() {
    return this.verifyOtpFormgroup.controls;
  }
  get f() {
    return this.addUserFormgroup.controls;
  }
  public emitService = new EventEmitter();
  constructor(private _commonBehaviorChangeService: CommonBehaviorChangeService, private modalService: NgbModal, private formBuilder: FormBuilder, private wssigninservice: WsSignInService, private toast: ToastrService, private router: Router) {
    this.signInFormgroup = this.formBuilder.group({
      phone_number: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]]
    });
    this.verifyOtpFormgroup = this.formBuilder.group({
      otp: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{4}$")]]
    });
    this.addUserFormgroup = this.formBuilder.group({
      first_name: [''],
      last_name: [''],
      email: ['', [Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
      gender: [''],
      is_active: [true]
    })
  }

  savePhone() {
    this.type = 2

  }

  /**
 * for Get OTP
 */
  async getOtp() {
    this.isLoading = true;
    this.resendLoader = true;
    const getOtp = this.wssigninservice.getOtp(this.signInFormgroup.controls['phone_number'].value)
    await lastValueFrom(getOtp).then(async response => {
      if (response && response.statusCode == 200) {
        this.isLoading = false;
        this.resendLoader = false;
        this.type = 3;
      } else {
        this.isLoading = false;
        this.resendLoader = false;
      }
    })
  }

  /**
* for Verify OTP
*/
  async loginWithOTP() {
    this.isLoading = true;
    const verifyOtp = this.wssigninservice.loginWithOTP(this.signInFormgroup.controls['phone_number'].value, this.verifyOtpFormgroup.controls['otp'].value)
    await lastValueFrom(verifyOtp).then(async response => {
      if (response && response.statusCode == 200) {
        SharedPrefrences.setUserData(response.data)
        SharedPrefrences.setToken(response.data.accessToken)
        SharedPrefrences.setUserId(response.data && response.data.id)
        this._commonBehaviorChangeService.updateProfileData(true)
        this.isLoading = false;
        if (response.data.first_name == null || response.data.first_name == '') {
          this.type = 2;
          this.userId = response.data && response.data.id
        } else {
          if(this.productType == true){
            this.emitService.emit(true);
            this.modalService.dismissAll();
          }
          else{
            this.router.navigate(['home-page/']).then(() => {
              this.emitService.emit(true)
              this.modalService.dismissAll();
            })
          }
        }
      } else {
        this.isLoading = false;
        this.toast.error("OTP does not match!");
      }
    })
  }

  genderDropdown() {
    $('.gender-menu').toggleClass('dropdown-gender');
    $('.gender-select-new').slideToggle();
  }

  async addUser() {
    this.isLoading = true;
    this.mUpdateUserRequest.id = this.userId
    this.mUpdateUserRequest.first_name = this.addUserFormgroup.controls['first_name'].value
    this.mUpdateUserRequest.last_name = this.addUserFormgroup.controls['last_name'].value
    this.mUpdateUserRequest.email = this.addUserFormgroup.controls['email'].value
    this.mUpdateUserRequest.gender = "" + this.addUserFormgroup.controls['gender'].value

    const adminUserRegistration = this.wssigninservice.updateUser(this.mUpdateUserRequest);
    await lastValueFrom(adminUserRegistration).then(async response => {
      if (response && response.statusCode == 200) {
        SharedPrefrences.setUserData(response.data)
        SharedPrefrences.setToken(response.data.accessToken)
        SharedPrefrences.setUserId(response.data && response.data.id)
        this._commonBehaviorChangeService.updateProfileData(true)
        this.isLoading = false;
        if(this.productType == true){
          this.emitService.emit(true);
          this.modalService.dismissAll();
        }
        else{
          this.router.navigate(['home-page/']).then(() => {
            this.emitService.emit(true)
            this.modalService.dismissAll();
          })
        }

      } else {
        this.isLoading = false;
      }
    })
  }

  closeButtonClick() {
    this.modalService.dismissAll();
  }

  selectGender(id: any) {
    this.selectedGender = id;
    this.addUserFormgroup.controls['gender'].setValue("" + this.selectedGender)
  }

}